import React, { Component } from 'react';
import { Col, Container, Row  } from 'reactstrap';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

export class MainMenu extends Component {

    render() {

        return (
            <Row id='mainmenu'>
                <Col xs="12">
                    <img src="/img/hero-startup.svg" />
                    <h1>Effortless Accountancy for Property Investors</h1>
                    
                    <h3>Contact details:</h3>
                    <p>
                        <a href="https://www.provestor.co.uk/?utm_source=calculator&utm_medium=referral">www.provestor.co.uk</a> <br />
                        <a href="mailto:support@provestor.co.uk">support@provestor.co.uk</a> <br />
                        <a href="tel:03302234275">0330 223 4275</a>
                    </p>

                    <h3>Agent support:</h3>
                    <p>
                        <a href="mailto:partners@provestor.co.uk">partners@provestor.co.uk</a> <br />
                        <a href="tel:01332460275">01332 460275</a>
                    </p>

                </Col>
            </Row>
        );
    }
}



export default connect()(MainMenu);


// WEBPACK FOOTER //
// ./src/Features/MainMenu/MainMenu.jsx